module.exports = "<div *ngFor=\"let blog of blogs\">\n  <app-blogitem [itemid]=\"blog\"></app-blogitem>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/devblog/devblog.component.html
// module id = ./src/app/components/devblog/devblog.component.html
// module chunks = main